export enum DesignableObjectCreationMethod {
    CLONING = "C",
    DESERIALIZING = "D",
    DROPPING_IN_DESIGNER = "R",
    NORMAL = "N"
}
